import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import axios from "axios";
import swal from "sweetalert";
import MDBox from "admin/components/MDBox";
import MDTypography from "admin/components/MDTypography";
import DashboardLayout from "admin/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "admin/examples/Navbars/DashboardNavbar";

const API = process.env.REACT_APP_APIHOST || "http://localhost:3033";
const FREQUENCIES = [{v:'daily',l:'Daily'},{v:'weekly',l:'Weekly'},{v:'biweekly',l:'Every 2 weeks'},{v:'monthly',l:'Monthly'},{v:'once',l:'Once'}];

function EmailReports() {
    const [tab, setTab] = useState('campaigns');
    const [campaigns, setCampaigns] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [users, setUsers] = useState([]);
    const [showNew, setShowNew] = useState(false);
    const [form, setForm] = useState({ name:'', templateId:'', recipients:[], countries:[], frequency:'daily', sendTime:'08:00' });
    const [sending, setSending] = useState(null);
    const [editId, setEditId] = useState(null);

    useEffect(() => { fetchAll(); }, []);

    const fetchAll = () => {
        axios.get(API + '/email-reports/campaigns').then(r => { if(r.data.status) setCampaigns(r.data.data) });
        axios.get(API + '/email-reports/templates').then(r => { if(r.data.status) setTemplates(r.data.data) });
        axios.get(API + '/email-reports/available-recipients').then(r => { if(r.data.status) setUsers(r.data.data) });
    };

    const createCampaign = async () => {
        if(!form.name || !form.templateId) { swal('Error','Name and template required','error'); return; }
        if(form.recipients.filter(r=>r.included).length === 0) { swal('Error','Select at least one recipient','error'); return; }
        await axios.post(API + '/email-reports/campaigns', form);
        setShowNew(false);
        setForm({ name:'', templateId:'', recipients:[], countries:[], frequency:'daily', sendTime:'08:00' });
        fetchAll();
    };

    const toggleRecipient = (user) => {
        const existing = form.recipients.find(r => r.email === user.email);
        if (existing) {
            setForm({...form, recipients: form.recipients.map(r => r.email === user.email ? {...r, included: !r.included} : r)});
        } else {
            setForm({...form, recipients: [...form.recipients, { email: user.email, firstName: user.firstName, lastName: user.lastName, included: true }]});
        }
    };

    const isIncluded = (email) => { const r = form.recipients.find(x => x.email === email); return r ? r.included : false; };

    const startEdit = (campaign) => {
        setEditId(campaign._id);
        setForm({
            name: campaign.name,
            templateId: campaign.templateId?._id || campaign.templateId || '',
            recipients: campaign.recipients || [],
            countries: campaign.countries || [],
            frequency: campaign.frequency || 'daily',
            sendTime: campaign.sendTime || '08:00'
        });
        setShowNew(true);
    };

    const saveCampaign = async () => {
        if(!form.name || !form.templateId) { swal('Error','Name and template required','error'); return; }
        if(form.recipients.filter(r=>r.included).length === 0) { swal('Error','Select at least one recipient','error'); return; }
        if (editId) {
            await axios.put(API + '/email-reports/campaigns/' + editId, form);
            setEditId(null);
        } else {
            await axios.post(API + '/email-reports/campaigns', form);
        }
        setShowNew(false);
        setForm({ name:'', templateId:'', recipients:[], countries:[], frequency:'daily', sendTime:'08:00' });
        fetchAll();
    };

    const sendNow = async (id) => {
        setSending(id);
        try {
            const r = await axios.post(API + '/email-reports/campaigns/' + id + '/send');
            swal('Sent', `Sent to ${r.data.data?.sent || 0} recipients`, 'success');
            fetchAll();
        } catch(e) { swal('Error', 'Failed to send', 'error'); }
        setSending(null);
    };

    const deleteCampaign = async (id) => {
        swal({ title: "Delete?", icon: "warning", buttons: true, dangerMode: true }).then(async (ok) => {
            if (ok) { await axios.delete(API + '/email-reports/campaigns/' + id); fetchAll(); }
        });
    };

    const toggleActive = async (c) => {
        await axios.put(API + '/email-reports/campaigns/' + c._id, { active: !c.active });
        fetchAll();
    };

    const inp = { background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:3, padding:'8px 12px', color:'#e6e6e6', fontSize:12, outline:'none', width:'100%', boxSizing:'border-box' };
    const lbl = { fontSize:10, color:'#888', textTransform:'uppercase', letterSpacing:1, marginBottom:4, display:'block' };

    const COUNTRIES = ["Saudi Arabia","United Arab Emirates","Qatar","Bahrain","Kuwait","Oman","Iraq","Iran","Israel","Palestine","Lebanon","Syria","Yemen","Jordan","Egypt","Turkey","Libya","Sudan","Somalia","Ukraine","Russia","Afghanistan","Pakistan"];

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={2} pb={2}>
                <Card>
                    <MDBox px={2} pt={1} pb={0.5} display="flex" justifyContent="space-between" alignItems="center">
                        <MDBox display="flex" gap={1}>
                            {['campaigns','templates'].map(t => (
                                <MDTypography key={t} component="span" onClick={() => setTab(t)}
                                    sx={{ fontSize:'11px', textTransform:'uppercase', letterSpacing:'1.5px', cursor:'pointer', padding:'6px 14px', borderRadius:'2px',
                                        background: tab===t ? 'rgba(194,151,23,0.1)' : 'transparent',
                                        color: tab===t ? '#C29717' : '#666' }}>{t}</MDTypography>
                            ))}
                        </MDBox>
                        {tab === 'campaigns' && (
                            <MDTypography component="span" sx={{ color:'#C29717', fontSize:'12px', cursor:'pointer', display:'flex', alignItems:'center', gap:'4px' }}
                                onClick={() => { setShowNew(!showNew); setEditId(null); setForm({ name:'', templateId:'', recipients:[], countries:[], frequency:'daily', sendTime:'08:00' }); }}>
                                <Icon sx={{ fontSize:'14px !important' }}>add_circle_outline</Icon> {showNew ? 'Cancel' : 'New campaign'}
                            </MDTypography>
                        )}
                    </MDBox>

                    {/* NEW CAMPAIGN FORM */}
                    {tab === 'campaigns' && showNew && (
                        <MDBox px={2} py={1.5} sx={{ borderBottom:'1px solid rgba(255,255,255,0.06)', borderTop:'1px solid rgba(255,255,255,0.06)' }}>
                            <MDBox display="flex" gap={1} mb={1}>
                                <div style={{flex:1}}><label style={lbl}>Campaign name *</label><input style={inp} value={form.name} onChange={e => setForm({...form, name:e.target.value})} /></div>
                                <div style={{flex:1}}><label style={lbl}>Template *</label>
                                    <select style={{...inp, height:34}} value={form.templateId} onChange={e => setForm({...form, templateId:e.target.value})}>
                                        <option value="">Select...</option>
                                        {templates.map(t => <option key={t._id} value={t._id}>{t.name}</option>)}
                                    </select>
                                </div>
                            </MDBox>
                            <MDBox display="flex" gap={1} mb={1}>
                                <div style={{flex:1}}><label style={lbl}>Frequency</label>
                                    <select style={{...inp, height:34}} value={form.frequency} onChange={e => setForm({...form, frequency:e.target.value})}>
                                        {FREQUENCIES.map(f => <option key={f.v} value={f.v}>{f.l}</option>)}
                                    </select>
                                </div>
                                <div style={{width:120}}><label style={lbl}>Time (Dubai)</label>
                                    <input type="time" style={inp} value={form.sendTime} onChange={e => setForm({...form, sendTime:e.target.value})} />
                                </div>
                            </MDBox>

                            <label style={lbl}>Countries</label>
                            <MDBox display="flex" gap={0.5} flexWrap="wrap" mb={1.5}>
                                {COUNTRIES.map(c => (
                                    <span key={c} onClick={() => setForm({...form, countries: form.countries.includes(c) ? form.countries.filter(x=>x!==c) : [...form.countries, c]})}
                                        style={{ fontSize:10, padding:'2px 8px', borderRadius:2, cursor:'pointer',
                                            background: form.countries.includes(c) ? 'rgba(194,151,23,0.15)' : 'rgba(255,255,255,0.04)',
                                            border: '1px solid ' + (form.countries.includes(c) ? 'rgba(194,151,23,0.3)' : 'rgba(255,255,255,0.08)'),
                                            color: form.countries.includes(c) ? '#C29717' : '#888' }}>{c}</span>
                                ))}
                            </MDBox>

                            <label style={lbl}>Recipients</label>
                            <MDBox display="flex" gap={0.5} flexWrap="wrap" mb={1.5}>
                                {users.map(u => (
                                    <span key={u._id} onClick={() => toggleRecipient(u)}
                                        style={{ fontSize:10, padding:'2px 8px', borderRadius:2, cursor:'pointer',
                                            background: isIncluded(u.email) ? 'rgba(76,175,80,0.15)' : 'rgba(255,255,255,0.04)',
                                            border: '1px solid ' + (isIncluded(u.email) ? 'rgba(76,175,80,0.3)' : 'rgba(255,255,255,0.08)'),
                                            color: isIncluded(u.email) ? '#4CAF50' : '#888' }}>
                                        {u.firstName} {u.lastName} ({u.email})
                                    </span>
                                ))}
                            </MDBox>

                            <span onClick={saveCampaign} style={{ padding:'6px 18px', background:'rgba(194,151,23,0.15)', border:'1px solid rgba(194,151,23,0.3)', borderRadius:2, color:'#C29717', fontSize:11, cursor:'pointer', fontWeight:600 }}>{editId ? 'Save changes' : 'Create campaign'}</span>
                        </MDBox>
                    )}

                    {/* CAMPAIGNS LIST */}
                    {tab === 'campaigns' && (
                        <MDBox px={2} py={1}>
                            {campaigns.length === 0 ? (
                                <MDTypography sx={{ color:'#888', fontSize:'13px', py:2, textAlign:'center' }}>No campaigns</MDTypography>
                            ) : campaigns.map(c => (
                                <MDBox key={c._id} sx={{ borderBottom:'1px solid rgba(255,255,255,0.04)', py:1.2, opacity: c.active ? 1 : 0.4 }}>
                                    <MDBox display="flex" justifyContent="space-between" alignItems="flex-start">
                                        <MDBox>
                                            <MDBox display="flex" gap={0.5} alignItems="center" mb={0.3}>
                                                <span style={{fontSize:13,fontWeight:500,color:'#e6e6e6'}}>{c.name}</span>
                                                <span style={{fontSize:9,color:'#C29717',background:'rgba(194,151,23,0.08)',borderRadius:2,padding:'0 5px'}}>{c.frequency}</span>
                                                <span style={{fontSize:9,color:'#888'}}>{c.sendTime} Dubai</span>
                                            </MDBox>
                                            <MDBox display="flex" gap={0.5} flexWrap="wrap" mb={0.3}>
                                                {(c.countries||[]).map(co => <span key={co} style={{fontSize:9,color:'#C29717',background:'rgba(194,151,23,0.06)',borderRadius:2,padding:'0 5px'}}>{co}</span>)}
                                            </MDBox>
                                            <span style={{fontSize:10,color:'#555'}}>
                                                {c.recipients?.filter(r=>r.included).length || 0} recipients · Template: {c.templateId?.name || '—'} · Sent: {c.sentCount || 0}x
                                                {c.lastSentAt && <span> · Last: {new Date(c.lastSentAt).toLocaleDateString()}</span>}
                                                {c.nextRunAt && <span style={{color:'#C29717'}}> · Next: {(() => { const diff = Math.round((new Date(c.nextRunAt) - new Date()) / 60000); if(diff < 0) return 'overdue'; if(diff < 60) return 'in ' + diff + 'min'; if(diff < 1440) return 'in ' + Math.round(diff/60) + 'h'; return 'in ' + Math.round(diff/1440) + 'd'; })()}</span>}
                                            </span>
                                        </MDBox>
                                        <MDBox display="flex" gap={0.8} alignItems="center">
                                            <span onClick={() => startEdit(c)} title="Edit" style={{color:'#888',cursor:'pointer',fontSize:12}}>✎</span>
                                            <span onClick={() => sendNow(c._id)} title="Send now"
                                                style={{color:'#C29717',cursor:'pointer',fontSize:11,border:'1px solid rgba(194,151,23,0.3)',borderRadius:2,padding:'1px 6px',background:'rgba(194,151,23,0.08)'}}>
                                                {sending === c._id ? '...' : '▶'}
                                            </span>
                                            <span onClick={() => toggleActive(c)} style={{width:12,height:12,borderRadius:2,border:'1px solid '+(c.active?'#4CAF50':'rgba(255,255,255,0.15)'),background:c.active?'rgba(76,175,80,0.15)':'transparent',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',fontSize:8,color:'#4CAF50'}}>{c.active?'✓':''}</span>
                                            <span onClick={() => deleteCampaign(c._id)} style={{color:'#888',cursor:'pointer',fontSize:12}}>x</span>
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            ))}
                        </MDBox>
                    )}

                    {/* TEMPLATES LIST */}
                    {tab === 'templates' && (
                        <MDBox px={2} py={1}>
                            {templates.length === 0 ? (
                                <MDTypography sx={{ color:'#888', fontSize:'13px', py:2, textAlign:'center' }}>No templates</MDTypography>
                            ) : templates.map(t => (
                                <MDBox key={t._id} sx={{ borderBottom:'1px solid rgba(255,255,255,0.04)', py:1.2 }}>
                                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                                        <MDBox>
                                            <span style={{fontSize:13,fontWeight:500,color:'#e6e6e6'}}>{t.name}</span>
                                            {t.isDefault && <span style={{fontSize:9,color:'#C29717',marginLeft:6,background:'rgba(194,151,23,0.08)',borderRadius:2,padding:'0 5px'}}>default</span>}
                                            <div style={{fontSize:10,color:'#888',marginTop:2}}>{t.description}</div>
                                            <div style={{fontSize:10,color:'#555',marginTop:2}}>Subject: {t.subject} · Period: last {t.daysBack} days · Blocks: {(t.contentBlocks||[]).join(', ')}</div>
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            ))}
                        </MDBox>
                    )}
                </Card>
            </MDBox>
        </DashboardLayout>
    );
}

export default EmailReports;
